<template>
  <div class="vmp-room-record-container">
    <div class="vmp-room-record vmp-room-operation" :class="{ recording: recording }" v-if="living">
      <i class="vh-iconfont vh-full-brush-l"></i>
      {{ statusText }}
    </div>
    <ol class="vmp-record-buttons">
      <li class="vmp-record-button" v-show="!recorded" @click="record">
        <i class="vh-iconfont vh-full-brush-l"></i>
        {{ $t('host.k_507001') }}
      </li>
      <li class="vmp-resume-button" v-show="recorded && !paused" @click="pause">
        <i class="vh-iconfont vh-a-line-videopause"></i>
        {{ $t('host.k_507002') }}
      </li>
      <li class="vmp-recover-button" v-show="paused && recorded" @click="reRecord">
        <i class="vh-iconfont vh-full-brush-l"></i>
        {{ $t('host.k_507003') }}
      </li>
      <li class="vmp-stop-button" v-show="recorded && !paused" @click="stop(true)">
        <i class="vh-iconfont vh-line-square"></i>
        {{ $t('host.k_507004') }}
      </li>
    </ol>
  </div>
</template>
<script>
  import { useRoomBaseServer } from 'middle-domain';
  export default {
    name: 'RecordControl',
    data() {
      return {
        disabled: true,
        paused: false,
        recorded: false, // 是否开启录制（包括暂停）
        statusText: this.$t('host.k_507001'),
        recording: false // 是否正在录制（不包括暂停）
      };
    },
    computed: {
      living() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      }
    },
    mounted() {
      if (this.$domainStore.state.roomBaseServer.watchInitData.cut_record_status == 2) {
        this.recorded = true;
        this.paused = true;
        this.statusText = this.$t('host.k_507002');
        this.recording = false;
      } else if (this.$domainStore.state.roomBaseServer.watchInitData.cut_record_status == 1) {
        this.recorded = true;
        this.statusText = this.$t('host.k_507005');
        this.recording = true;
      }
    },
    methods: {
      pause() {
        if (!this.recorded) {
          return;
        }
        this.paused = true;
        this.statusText = this.$t('host.k_507002');
        this.recording = false;
        window.vhallReportForProduct && window.vhallReportForProduct.report(110002);
        useRoomBaseServer().pauseRecordInLive();
      },

      record() {
        if (!this.recorded) {
          this.recorded = true;
          this.statusText = this.$t('host.k_507005');
          window.vhallReportForProduct && window.vhallReportForProduct.report(110001);
          this.recording = true;
          useRoomBaseServer().startRecordInLive();
        }
      },

      stop(mark, isLiveStop) {
        if (!this.recording) return;
        this.recorded = false;
        this.statusText = this.$t('host.k_507001');
        window.vhallReportForProduct && window.vhallReportForProduct.report(110003);
        this.recording = false;
        if (!isLiveStop) {
          // 增加isLiveStop  是否为结束直播导致停止录制    新版这种情况不掉接口
          useRoomBaseServer().endRecordInLive();
        }
        if (mark) {
          this.$message.success(this.$t('host.k_507006'));
        }
      },

      reRecord() {
        this.paused = false;
        this.statusText = this.$t('host.k_507005');
        this.recording = true;
        useRoomBaseServer().startRecordInLive();
      }
    }
  };
</script>

<style lang="less">
  .vmp-room-record-container {
    height: 100%;
    display: flex;
    align-items: center;
    align-content: center;
    position: relative;
    .vmp-room-record {
      box-sizing: border-box;
      border: 1px solid rgba(151, 151, 151, 1);
      line-height: 24px;
      & > i.vh-full-brush-l {
        font-size: 12px;
        transform: scale(0.6);
        margin-right: 5px;
        vertical-align: middle;
      }
    }
    .vmp-room-operation {
      min-width: 100px;
      height: 26px;
      border-radius: 100px;
      font-size: 14px;
      text-align: center;
      line-height: 26px;
      color: rgba(255, 255, 255, 1);
      margin-right: 10px;
      padding: 0 10px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .vmp-record-buttons {
      z-index: 3;
      display: none;
      position: absolute;
      top: 45px;
      left: -6px;
      width: 112px;
      background-color: #434343;
      text-align: center;
      padding: 3px 0;
      border-radius: 3px;
      border: 1px solid #2d2d2d;
      overflow: hidden;
      color: #ececec;
      box-sizing: border-box;
      & > li {
        width: 100%;
        height: 32px;
        line-height: 32px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        box-sizing: border-box;
        vertical-align: middle;
        & > i {
          font-size: 7px;
          transform: scale(0.6);
          margin-right: 11px;
          vertical-align: middle;
        }
        &:hover {
          background-color: #1d1d1d;
        }
      }
    }
    &:hover {
      .vmp-record-buttons {
        display: block;
      }
    }
  }
</style>
